import React from "react";
import ReactDOM from "react-dom/client";
import "./css/reset.css";
import "./css/custom-properties.css";
import "./css/utility-classes.css";
import "./css/components.css";
// import "./css/index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename="fem-space-tourism-website">
    <App />
  </BrowserRouter>
);
